// Vue 3 + Vuetify 3
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";

// Vuetify 3
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";

import "./registerServiceWorker";
// Import http.js FIRST to setup axios
import "./api/http";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import CardLoading from "./components/shared/cardLoading";
import SnackComp from "./components/shared/snackComp";
import i18n from "./i18n";
import auth from "./plugins/vue-auth";

// Create Vuetify instance
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#003a3e"
        }
      }
    }
  },
  icons: {
    defaultSet: "mdi"
  }
});

// Create Vue app
const app = createApp(App);

// Global components
app.component("card-loading", CardLoading);
app.component("snack-comp", SnackComp);

// Plugins
app.use(router);
app.use(store);
app.use(vuetify);
app.use(VueSweetalert2, {
  confirmButtonColor: "#003a3e",
  cancelButtonColor: "#6c757d",
});
app.use(i18n);
app.use(auth);

// TODO: vue-auth needs Vue 3 compatible setup
// For now, auth is disabled - will need migration

app.mount("#app");
